"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("spry-react/utils/react-ext");
require("./link.less");
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.render = function () {
        var props = this.props;
        if (props.disabled) {
            return React.createElement("a", { ref: this.props.anchorRef, href: "#", onClick: getPreventDefaultClickHandler(), title: props.title, className: props.className, disabled: true, "aria-disabled": true, id: props.id, style: props.style }, props.children);
        }
        if (isUrlLink(props)) {
            var target = props.targetNewWindow ? '_blank' : '_self';
            return React.createElement("a", { ref: this.props.anchorRef, href: props.url, target: target, title: props.title, className: props.className, id: props.id, style: props.style }, props.children);
        }
        if (isOnClickLink(props)) {
            return React.createElement("a", { ref: this.props.anchorRef, href: "#", onClick: getPreventDefaultClickHandler(props.onClick), title: props.title, className: props.className, id: props.id, style: props.style }, props.children);
        }
        console.error('Error creating Link component. If you meant to create a disabled link, set the disabled prop. Otherwise, make sure your url or onClick prop is defined correctly and not null.');
        return React.createElement("a", null, this.props.children);
    };
    return Link;
}(React.PureComponent));
exports.Link = Link;
function isUrlLink(linkProps) {
    return linkProps.url !== undefined;
}
function isOnClickLink(linkProps) {
    return linkProps.onClick !== undefined;
}
function getPreventDefaultClickHandler(onClick) {
    return function (e) {
        var _a;
        e.preventDefault();
        (_a = onClick) === null || _a === void 0 ? void 0 : _a(e);
    };
}
exports.getPreventDefaultClickHandler = getPreventDefaultClickHandler;
